export const DEFAULT_FONT_SIZE = '16px'
export const BIG_FONT_SIZE = '15px'
export const MEDIUM_FONT_SIZE = '11.5px'
export const SMALL_FONT_SIZE = '8.5px'
